// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-8Gs","questions":"styles_questions__AXi-d","footer":"styles_footer__MYRzi"};